import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EmptyStateProps {
    icon: ReactNode
    title: string
    description?: ReactNode
    action?: ReactNode
    className?: string
}

export const EmptyState: FC<EmptyStateProps> = ({ icon, title, description, action, className }): ReactNode => {
    return (
        <div className={cn('flex flex-col items-center rounded-3xl border border-dashed border-white/10 px-6 py-16 text-center', className)}>
            <div className='grid size-12 place-items-center rounded-2xl bg-white/[0.06] text-foreground/80'>
                {icon}
            </div>

            <h2 className='mt-5 font-heading text-3xl text-foreground'>
                {title}
            </h2>

            {description && (
                <div className='mt-2 max-w-md text-sm leading-relaxed text-muted-foreground'>
                    {description}
                </div>
            )}

            {action && (
                <div className='mt-6 flex flex-wrap justify-center gap-3'>
                    {action}
                </div>
            )}
        </div>
    )
}
